import { ApolloQueryResult, gql, useQuery } from '@apollo/client';
import {
  CSGetEntityUsersByFirmId,
  CSGetEntityUsersOnlyByFirmId,
  EntityUser,
  EntityUserRole,
} from '@admiin-com/ds-graphql';
import { mergeUniqueItems } from '@admiin-com/ds-common';
import { useFirmId } from '../../../hooks/useClientWorkflow/useClientWorkflow';
interface UseFirmEntityUsersProps {
  searchName?: string;
  clientGroupCode?: string;
  skip?: boolean;
  limit?: number;
  onlyUsers?: boolean;
  includeArchived?: boolean;
  archivedOnly?: boolean;
}

interface UserEntitiesResponse {
  entityUsers: EntityUser[];
  total: number;
  error: Error | undefined;
  hasNextPage: boolean;
  handleLoadMore: () => void;
  loading: boolean;
  refetch: () => Promise<ApolloQueryResult<any>>;
}

export const useFirmEntityUsers = ({
  searchName,
  clientGroupCode,
  limit = 20,
  skip = false,
  onlyUsers = false,
  includeArchived = false,
  archivedOnly = false,
}: UseFirmEntityUsersProps): UserEntitiesResponse => {
  const { firmId } = useFirmId();
  const {
    data: entityUsersData,
    fetchMore,
    error: listEntitiesError,
    loading,
    refetch,
  } = useQuery(
    gql(onlyUsers ? CSGetEntityUsersOnlyByFirmId : CSGetEntityUsersByFirmId),
    {
      notifyOnNetworkStatusChange: skip ? false : true,
      variables: {
        firmId,
        searchName,
        limit,
        clientGroupCode: clientGroupCode,
        roles: [EntityUserRole.ACCOUNTANT],
        includeArchived,
        archivedOnly,
        // filter: clientCode ? { clientCode: { eq: clientCode } } : undefined,
      },
      skip: !firmId || skip,
      fetchPolicy: 'cache-and-network',
    }
  );
  const entityUsers = entityUsersData?.entityUsersByFirmId?.items ?? [];
  const total = entityUsersData?.entityUsersByFirmId?.total ?? 0;
  const hasNextPage = total > (entityUsers?.length ?? 0);
  const handleLoadMore = async () => {
    if (!hasNextPage || loading) return;
    console.log('Loading more');
    await fetchMore({
      variables: {
        from: entityUsers?.length,
        // limit: entityUsers?.length + 20,
      },
      updateQuery: (prevResult, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prevResult;
        return {
          ...fetchMoreResult,
          entityUsersByFirmId: {
            ...fetchMoreResult.entityUsersByFirmId,
            items: mergeUniqueItems(
              prevResult.entityUsersByFirmId?.items ?? [],
              fetchMoreResult.entityUsersByFirmId?.items ?? [],
              ['id', 'entityId']
            ),
          },
        };
      },
    });
  };

  return {
    entityUsers,
    total,
    refetch,
    handleLoadMore,
    error: listEntitiesError,
    hasNextPage,
    loading,
  };
};
